import { LookupWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Lookup')
export class LookupConnectorProvider extends ConnectorProvider<LookupWorkflowNode> {}
